import { styled } from "@mui/material";

export const Label = styled("label")({
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  userSelect: "none",
});
